import { render, staticRenderFns } from "./NavVerticalGeo copy.vue?vue&type=template&id=5a58af7c&scoped=true"
import script from "./NavVerticalGeo copy.vue?vue&type=script&lang=js"
export * from "./NavVerticalGeo copy.vue?vue&type=script&lang=js"
import style0 from "./NavVerticalGeo copy.vue?vue&type=style&index=0&id=5a58af7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a58af7c",
  null
  
)

export default component.exports